<section [ngClass]="getMapClasses()">
  <stumpy-item-location *ngFor="let id of getItemIds()" [itemLocationId]="id"></stumpy-item-location>
  <stumpy-dungeon-location *ngFor="let id of getDungeonIds()" [dungeonLocationId]="id"></stumpy-dungeon-location>
</section>
